import React from 'react';

// Components
import HomeInputComponent from './HomeInputComponent';

// Types
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}
const HomeInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  ...otherProps
}) => {
  switch (null) {
    default:
      return <HomeInputComponent {...otherProps} />;
  }
};

export default HomeInputPicker;
